import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Person as PersonIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { Text, Theme, Services, Content } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';

import MasterSettings from '../components/MasterSettings.js';
import { logout } from '../actions/master.js';
import MasterMetaMenu from '../components/MasterMetaMenu.js';
import logoImg from '../assets/logo-medium.png';
import permissionLevel from '../services/permissions.js';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    [theme.breakpoints.down(2300)]: {
        width: '75%'
    },
    [theme.breakpoints.down(2000)]: {
        width: '90%'
    },
    [theme.breakpoints.down(600)]: {
        width: '95%'
    },
    [theme.breakpoints.down(400)]: {
        width: '98%'
    },
    margin: '0 auto',
    width: '55%',
    maxWidth: 1350
}));

class Header extends Component {
    state = {
        modalOpen: false,
        anchorEl: null
    };

    _toggleSettingsModal = () => {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
    };

    _handleMenuClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    _handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    };

    _goTo = (page) => {
        window.location.href = `/${ page }`;
    };

    _logout = () => {
        this.props.dispatch(logout());
    };

    render() {
        const { access: accessType } = this.props.master;

        const styles = {
            header: {
                backgroundColor: Theme.colors.surface,
                boxShadow: 'none'
            },
            headerSettingsIcon: {
                color: Theme.colors.mainTextGrey,
                marginLeft: 'auto',
                cursor: 'pointer'
            },
            breadCrumbs: {
                display: 'flex',
                alignItems: 'center'
            },
            breadCrumbIcon: {
                color: Theme.colors.mediumGrey,
                marginRight: '5px',
                lineHeight: '28px',
                fontsize: '20px'
            },
            logoSmall: {
                width: '45px'
            },
            menuItemBorder: {
                borderBottom: `${ Theme.colors.surface } solid 1px`
            },
            menuLink: {
                color: Theme.colors.black,
                cursor: 'pointer',
                textDecoration: 'none',
                textDecorationColor: 'none'
            },
            navDropMenuItem: {
                height: 'auto',
                justifyContent: 'center',
                minWidth: '100%',
                padding: '5px',
                paddingTop: '10px'
            },
            navDropMenuItemMain: {
                padding: '30px',
                paddingTop: '20px',
                textAlign: 'center'
            },
            selectedTitle: {
                fontFamily: Theme.fonts.type.heading
            },
            subHeader: {
                backgroundColor: Theme.colors.subHeaderGrey,
                // width: '55%',
                // maxWidth: 1350,
                boxShadow: 'none'
            },
            titleLink: {
                color: Theme.colors.mediumDarkGrey,
                cursor: 'pointer',
                fontsize: '16px',
                letterSpacing: '0.6px',
                textDecoration: 'none',
                textDecorationColor: 'none'
            }
        };

        return (
            <div style={{ marginBottom: '20px' }}>
                <AppBar
                    position="static"
                    color="default"
                    style={styles.header}
                >
                    <StyledToolbar>
                        <Link to={`/`} style={styles.titleLink}>
                            <img
                                alt="Simply Benefits Logo"
                                src={ logoImg }
                                style={styles.logoSmall}
                            />
                        </Link>

                        <div style={{ marginLeft: 20 }}>
                            <Text
                                medium
                                bold={ this.props.selectedTitle === 'dashboard' }
                                margin="0 10px"
                                display="inline"
                                link={`/`}
                            >
                                Dashboard
                            </Text>

                            <Text
                                medium
                                bold={this.props.selectedTitle === 'adjudication'}
                                margin="0 10px"
                                display="inline"
                                link={`/adjudication`}
                            >
                                Adjudication
                            </Text>

                            {
                                permissionLevel('Administration', accessType).includes('read')
                                    ? <Text
                                        medium
                                        bold={this.props.selectedTitle === 'administration'}
                                        margin="0 10px"
                                        display="inline"
                                        link={`/administration`}
                                    >
                                        Administration
                                    </Text>
                                    : null
                            }

                            <Text
                                medium
                                bold={this.props.selectedTitle === 'advisors'}
                                margin="0 10px"
                                display="inline"
                                link={`/advisors`}
                            >
                                Advisors
                            </Text>

                            <Text
                                medium
                                bold={this.props.selectedTitle === 'accounts'}
                                margin="0 10px"
                                display="inline"
                                link={`/accounts`}
                            >
                                Accounts
                            </Text>

                            <Text
                                medium
                                bold={this.props.selectedTitle === 'members'}
                                margin="0 10px"
                                display="inline"
                                link={`/members`}
                            >
                                Members
                            </Text>
                        </div>

                        <PersonIcon style={styles.headerSettingsIcon} onClick={this._handleMenuClick} />

                        <MasterMetaMenu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this._handleCloseMenu}
                            navigate={(page) => this._goTo(page)}
                            email={this.props.email}
                            toggleModal={this._toggleSettingsModal}
                            hideModal={this._toggleSettingsModal}
                            handleCloseMenu={this._handleCloseMenu}
                            logout={this._logout}
                        />

                    </StyledToolbar>
                </AppBar>

                { /* subheader and breadcrumb handling */ }
                <AppBar
                    position="static"
                    color="default"
                    style={styles.subHeader}
                >
                    <StyledToolbar variant="dense">
                        {
                            this.props.breadcrumbs ?
                                <Content customStyle={ { ...styles.breadCrumbs, margin: "0 0 0 0" } }>
                                    {
                                        this.props.breadcrumbs.map((breadcrumb) => (
                                            <React.Fragment key={Services.concatTokens(breadcrumb.title)} >
                                                <Text
                                                    onClick={breadcrumb.onClick || null}
                                                    align="center"
                                                    medium
                                                    margin="0px 5px 0px 0px"
                                                    display="inline-block"
                                                    customStyle={{ letterSpacing: '0.6px', cursor: 'pointer' }}
                                                    link={ breadcrumb.link || null }
                                                >
                                                    { breadcrumb.title }
                                                </Text>

                                                <ChevronRightIcon style={styles.breadCrumbIcon} />
                                            </React.Fragment>
                                        ))
                                    }

                                    <Text
                                        medium
                                        isSelected={true}
                                        color={Theme.colors.skyBlue}
                                        display="inline-block"
                                        customStyle={{ letterSpacing: '0.6px' }}
                                    >
                                        {this.props.subHeader}
                                    </Text>

                                </Content>
                                :
                                <Content customStyle={ { ...styles.breadCrumbs, margin: "0 0 0 0" } }>
                                    <Text
                                        align="center"
                                        bold
                                        mediumLarge
                                        margin="0px 20px 0px 0px"
                                        display="inline-block"
                                        customStyle={{ letterSpacing: '0.6px' }}
                                    >
                                        {this.props.subHeader}
                                    </Text>

                                    {
                                        this.props.sections &&
                                        this.props.sections.map((section) => {
                                            if (!section.isAvailable) {
                                                return null;
                                            }

                                            return (
                                                <Text
                                                    key={Services.concatTokens(section.name, section.isActive)}
                                                    align="center"
                                                    isSelected={section.isActive}
                                                    isSelectedColor={Theme.colors.skyBlue}
                                                    onClick={section.onSelect}
                                                    medium
                                                    margin="0px 20px 0px 0px"
                                                    display="inline-block"
                                                    customStyle={{ letterSpacing: '0.6px', cursor: 'pointer' }}
                                                    link={section.onSelect}

                                                >
                                                    {section.name}
                                                </Text>
                                            );
                                        })
                                    }
                                </Content>
                        }
                    </StyledToolbar>
                </AppBar>

                {
                    this.state.modalOpen &&
                        <MasterSettings
                            hideModal={this._toggleSettingsModal}
                        />
                }
            </div>
        );
    }
}

Header.propTypes = {
    email: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    email: state.master.email,
    master: state.master
});

export default connect(mapStateToProps)(Header);